import styled from 'styled-components/macro';
import { Col } from '@zendeskgarden/react-grid';
import { variables } from 'theme/variables';

const {
  spacing,
  spacing_lg: spacingLg,
  spacing_sm: spacingSm,
  custom_grey: customGrey,
  custom_blue: customBlue,
} = variables;

export const AttributesCol = styled('div')`
  min-width: 100%;
  @media (max-width: 1820px) {
    min-width: ${(props) => (props.isDashboard ? '1000px' : null)};
  }
  @media (max-width: 1687px) {
    min-width: ${(props) => (props.isDashboard ? '800px' : null)};
  }
  @media (max-width: 1479px) {
    min-width: ${(props) => (props.isDashboard ? '600px' : null)};
  }
  @media (max-width: 1300px) {
    min-width: ${(props) => (props.isDashboard ? '500px' : null)};
  }
  @media (max-width: 1200px) {
    min-width: ${(props) => (props.isDashboard ? '450px' : null)};
  }
  @media (max-width: 1130px) {
    min-width: ${(props) => (props.isDashboard ? '400px' : null)};
  }
  @media (max-width: 1080px) {
    min-width: ${(props) => (props.isDashboard ? '350px' : null)};
  }
  @media (max-width: 950px) {
    min-width: ${(props) => (props.isDashboard ? '300px' : null)};
  }
  @media (max-width: 900px) {
    width: auto;
    min-width: 200px;
    flex: 1;
  }
`;

export const HeroWrapper = styled('div')`
  h1 {
    ${(props) =>
      props.isDashboard ? 'padding-left: 0' : 'padding-left: 30px'};
    margin-bottom: 20px;
    font-weight: 600;
  }
  .listingTitle {
    display: flex;
  }
  #listingName {
    font-size: 1.9rem;
  }
  .listingImages {
    ${(props) => (!props.isDashboard ? 'overflow: hidden' : null)};
  }
  .listingDetails {
    display: flex;
    flex-wrap: nowrap;
  }
  .title-description {
    margin: ${spacingSm} 0 ${spacingLg};
    max-width: 900px;
  }
  #backButton {
    cursor: pointer;
  }
  @media (max-width: 1930px) {
    .attribute-description {
      ${(props) => (props.isDashboard ? 'margin-left: 50px' : null)};
    }
  }
  @media (max-width: 1820px) {
    .listingDetails {
      ${(props) =>
        props.isDashboard ? 'flex-wrap: wrap; flex-direction: column;' : null};
    }
    .attribute-description {
      ${(props) => (props.isDashboard ? 'margin-left: 0px' : null)};
    }
    .listingData {
      ${(props) => (props.isDashboard ? 'margin-top: 50px' : null)};
    }
  }
  @media (max-width: 1440px) {
    #listingName {
      margin-bottom: 0 !important;
    }
  }
  @media (max-width: 1300px) {
    .attribute-description {
      ${(props) => (props.isDashboard ? 'margin-left: 10px' : null)};
    }
  }
  @media (max-width: 1200px) {
    h1 {
      margin-bottom: 40px;
    }
    .attribute-description {
      display: block;
      margin-left: ${(props) => (props.isDashboard ? '10px' : '20px')};
    }
    .title-description {
      display: none;
    }
    #listingName {
      margin-bottom: 0px;
    }
    .listingData {
      margin-top: 50px;
    }
    ${(props) =>
      props.isDashboard
        ? null
        : `
    .listingDetails {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      margin: 0 auto;
    }
    `};
  }
  @media (max-width: 1170px) {
    #listingName {
      ${(props) => (props?.isDashboard ? 'font-size: 1.3rem' : null)};
    }
  }
  @media (max-width: 1024px) {
    .listingTitle {
      justify-content: flex-start;
    }
  }
  @media (max-width: 690px) {
    #backButton {
      display: none !important;
      width: 0px;
      height: 0px;
    }
  }
  @media (max-width: 915px) {
    .listingImages {
      ${(props) => (!props.isDashboard ? 'overflow: visible' : null)};
    }
  }
  @media (max-width: 425px) {
    #listingName {
      font-size: 1.1rem;
    }
  }
`;

export const Description = styled('div')`
  padding-right: 30px;
  min-width: 105px;
  .Title {
    font-size: 18px;
    color: ${customGrey};
    font-weight: 500;
  }
  #completeDescription {
    font-size: 14px;
    padding-top: 10px;
  }
  @media (max-width: 1200px) {
    padding-right: 0px;
    max-width: 500px;
  }
  @media (max-width: 1190px) {
    ${(props) => (props.isDashboard ? '60px' : null)};
  }
  @media (max-width: 425px) {
    width: 100%;
    .Title {
      font-size: 14px;
    }
    #completeDescription {
      font-size: 12px;
    }
  }
`;
export const AttributesTable = styled('div')`
  max-width: 800px;
  .attributeName {
    font-size: 16px;
    font-weight: 500;
    color: ${customGrey};
  }
  .attributeValue {
    font-weight: 600;
  }
  .attributeDataSet {
    padding: 7px 60px;
  }
  @media (max-width: 1300px) {
    .attributeDataSet {
      ${(props) =>
        props?.isDashboard ? 'padding: 7px 10px' : 'padding: 7px 60px'};
    }
  }
  @media (max-width: 1170px) {
    #locationDataSet {
      ${(props) =>
        props?.isDashboard
          ? 'display: flex; flex-wrap: wrap; wrap-direction: column;'
          : null};
    }
  }
  @media (max-width: 768px) {
    max-width: 95%;
    .attributeDataSet {
      padding: 7px 10px;
    }
  }
  @media (max-width: 425px) {
    max-width: 100%;
    .attributeName {
      font-size: 12px;
    }
    .attributeValue {
      font-size: 12px;
      font-weight: 600;
    }
    #locationDataSet {
      display: flex;
      flex-wrap: wrap;
      wrap-direction: column;
    }
  }
`;

export const ListingsActions = styled(Col)`
  width: 100%;
  margin-top: ${spacing};
  margin: 0 auto;
  #manageListingButton {
    width: 60%;
    max-width: 100%;
    font-size: 16px;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  }
  #submitInquiryButton {
    width: 60%;
    max-width: 100%;
    font-size: 16px;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  }
  .actionButtons {
    padding-top: 30px;
    display: flex;
    flex-wrap: no-wrap;
    justify-content: space-evenly;
    align-items: center;
  }
  @media (min-width: 970px) {
    margin-top: 0;
    width: auto;
    max-width: 290px;
  }
  @media (min-width: 1000px) {
    max-width: 310px;
  }
  @media (min-width: 1200px) {
    max-width: 330px;
  }
  @media (max-width: 425px) {
    #manageListingButton {
      width: 100%;
    }
    #submitInquiryButton {
      width: 100%;
    }
    .actionButtonName {
      display: none;
    }
  }
`;

export const ActionButton = styled('div')`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  color: ${customBlue};
  min-width: 100px;
  .actionButton {
    box-sizing: border-box;
    width: 17px;
    min-width: 17px;
    height: 50px;
    border-radius: 55%;
    margin-bottom: 10px;
  }
`;
